import type { QueryClient } from '@tanstack/react-query';
import { RouterProvider } from 'react-router/dom';
import { AppProviders } from './providers';
import { getRouter } from './router';

/**
 * The whole client app: providers + the data router (`react-router/dom` flushes for View Transitions).
 * `queryClient` is the cache `main.tsx` filled from the pre-rendered page, if there is one.
 */
export function App({ queryClient }: { queryClient?: QueryClient }) {
  return (
    <AppProviders {...(queryClient ? { queryClient } : {})}>
      <RouterProvider router={getRouter()} />
    </AppProviders>
  );
}
